// types for the document exchange service (*only* backend)
// see https://gitlab.com/prisma-capacity/platform/document-exchange/-/blob/master/src/main/resources/open-api.yml?ref_type=heads
import type { Link } from 'src/apis/api-utilities';
import type { DocumentStatus } from 'src/pages/shippers/documents/status';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export type DocumentType = 'BUSINESS_COMMUNICATION';

export const documentTypeLabels: Record<DocumentType, string> = {
  BUSINESS_COMMUNICATION: 'Business Communication',
};

export const documentTypeOptions = labelsToOptions(documentTypeLabels);

export const documentTypeValues = labelsToValues(documentTypeLabels);

export type OperatorDocumentTableList = {
  _links: {
    self: Link;
  };
  _embedded: {
    items: OperatorDocument[];
  };
  total: number;
  limit: number;
  offset: number;
};

export type DocumentsParams = {
  limit?: number;
  offset?: number;
  changedAtStart?: string | null;
  changedAtEnd?: string | null;
  documentName?: string | null;
  documentDescription?: string | null;
  documentStatus?: DocumentStatus[];
  documentType?: DocumentType[];
  operatorName?: string | null;
  sortDirection?: SortDirection;
  sortBy?: DocumentsSortBy;
  shipperId?: string | null;
};

export type SortDirection = 'asc' | 'desc';

export type DocumentsSortBy = 'CHANGED_AT';

export type OperatorDocument = {
  _links: {
    self: Link;
    getCurrentOperatorDocumentFile?: Link;
    editOperatorDocument?: Link;
    withdrawOperatorDocument?: Link;
    getOperatorDocumentVersionHistory?: Link;
  };
  operatorDocumentId: string;
  documentName: string;
  documentDescription: string;
  changedAt: string;
  documentType: DocumentType;
  documentStatus: DocumentStatus;
  operatorName: string;
};

export type OperatorDocumentFile = {
  _links: {
    self: Link;
  };
  fileName: string;
  downloadUrl: string;
};
